export const legalUrls = {
  // Privacy policy
  PRIVACY_POLICY_URL: `https://iodized-parent-254.notion.site/Informativa-Privacy-EffAI-294516d8da3080c58d18e2eb56317063`,
  // Terms of service
  TERMS_OF_SERVICE_URL: `/policy/tos.html`,
  // Cookie policy
  COOKIE_POLICY_URL: `https://iodized-parent-254.notion.site/Cookie-Policy-EffAI-294516d8da3080db82d2f1cc46d651e8`,

  RELAZIONE_SOSTENIBILITA_URL: `https://drive.google.com/file/d/1dz2ftiqp-gFu_TtGsCvtcPqAEq6Ke9GC/view?usp=sharing`,
};
